import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import CurrencyInput from '../global/CurrencyInput';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import Swal from "sweetalert2";
import UserBankAcountModel from "../../models/UserBankAcountModel";
import { RiWallet3Line, RiVipCrown2Fill, RiCloseLine, RiCheckLine } from "react-icons/ri";

const validationSchema = Yup.object().shape({
    account_balance: Yup.string().required('Không được để trống!'),
});

function ModalEditBalance(props) {
    const [initialValues, setInitialValues] = useState({
        user_bank_account_id: '',
        account_balance: '',
    });

    useEffect(() => {
        if (props) {
            setInitialValues({
                user_bank_account_id: props.user_bank_account_id,
                account_balance: props.account_balance,
            });
        }
    }, [props]);

    const onSubmit = (values) => {
        UserBankAcountModel.updateBalance(values).then((res) => {
            if (res.success == true) {
                Swal.fire({
                    icon: "success",
                    title: res.message,
                    showConfirmButton: true,
                    timer: 2000
                });
            } else {
                Swal.fire({
                    icon: "error",
                    title: res.data,
                    showConfirmButton: false,
                    timer: 2000
                });
            }
            handCloseModal();
            setTimeout(() => {
                props.reloadPage(props.id, props.type);
            }, 2000);
        }).catch(() => {
            Swal.fire({
                icon: "error",
                title: "Cập nhật thất bại!",
                showConfirmButton: false,
                timer: 2000
            });
        });
    };

    const handCloseModal = () => {
        props.onHide();
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setInitialValues((prevInitialValues) => ({
            ...prevInitialValues,
            [name]: value,
        }));
    };

    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter" className="d-flex align-items-center gap-2">
                    <RiWallet3Line size={18} style={{ color: 'var(--wus-text)' }} />
                    <span>Điều Chỉnh Số Dư Hiển Thị</span>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Formik
                    initialValues={initialValues}
                    enableReinitialize={true}
                    validationSchema={validationSchema}
                    onSubmit={onSubmit}
                >
                    {({ errors }) => (
                        <Form>
                            {props.is_from_combo == 1 ? (
                                <div className="d-flex align-items-center gap-2 p-3 mb-3" style={{ background: 'var(--wus-warning-bg)', border: '1px solid var(--wus-warning-border)', borderRadius: '10px', color: 'var(--wus-text-secondary)', fontSize: '12.5px' }}>
                                    <RiVipCrown2Fill size={20} style={{ color: 'var(--wus-warning-text)' }} className="flex-shrink-0" />
                                    <div>
                                        <strong style={{ color: 'var(--wus-warning-text)' }}>Đặc quyền Bank VIP Combo:</strong> Miễn phí <strong style={{ color: 'var(--wus-success-text)' }}>100% (0 VNĐ)</strong> phí sửa số dư hiển thị trên App!
                                    </div>
                                </div>
                            ) : (
                                <div className="p-3 mb-3" style={{ background: 'var(--wus-warning-bg)', border: '1px solid var(--wus-warning-border)', borderRadius: '10px', color: 'var(--wus-text-secondary)', fontSize: '12.5px' }}>
                                    ⚠️ <strong>Lưu ý:</strong> Phí thay đổi số dư hiển thị trên App là <strong style={{ color: 'var(--wus-text)' }}>49.000 VNĐ</strong> / lần cập nhật (trừ vào số dư Web). Nâng cấp VIP để được miễn phí 100%!
                                </div>
                            )}

                            <div className="mb-3">
                                <label htmlFor="account_balance" className="form-label">Số dư mới hiển thị trên App (VNĐ)</label>
                                <CurrencyInput
                                    className="form-control font-monospace"
                                    name="account_balance"
                                    id="account_balance"
                                    value={initialValues.account_balance}
                                    onChange={(e) => handleInputChange(e)}
                                    type="text"
                                    autoFocus
                                />
                                {errors.account_balance && (
                                    <div className="text-danger small mt-1">{errors.account_balance}</div>
                                )}
                            </div>

                            <div className="modal-footer px-0 pb-0 mt-2">
                                <button type="button" className="btn btn-secondary" onClick={props.onHide}>
                                    <RiCloseLine className="me-1" size={16} />
                                    Hủy bỏ
                                </button>
                                <button type="submit" className="btn btn-primary">
                                    <RiCheckLine className="me-1" size={16} />
                                    Cập nhật số dư
                                </button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </Modal.Body>
        </Modal>
    );
}

export default ModalEditBalance;